Object.assign = require("object-assign");

var keyMirror = require("keyMirror");

var Constants = keyMirror({
	INITIALIZE: null,
	GIFT_ARRAY_LOADED: null,
	SET_ANONYMOUS: null,
	SET_DONATION_FREQUENCY: null,
	SET_DONATION_PREMIUM: null,
	SET_GIFT_AMOUNT: null,
	SET_MINIMUM_AMOUNT: null,
	SET_RECURRING_START_DATE: null,
	SET_SUBACCOUNT_GIFT_AMOUNT: null,
	SET_USE_ON_DAY: null,
	SET_UPSELL: null
});

module.exports = Constants;



// WEBPACK FOOTER //
// ./Javascript/projectComponents/ProjectConstants.jsx